<template>
  <el-dialog
    :title="$t('share.title') || '分享商品'"
    :visible.sync="dialogVisible"
    width="400px"
    :before-close="handleClose"
  >
    <div class="share-dialog-content">
      <!-- 商品信息 -->
      <div class="product-info" v-if="product">
        <img :src="getImageUrl(product.mainImage || product.image)" class="product-thumb" />
        <div class="product-detail">
          <div class="product-name">{{ product.name }}</div>
          <div class="product-price">
            <span class="share-price">¥{{ sharePrice }}</span>
            <span class="original-price" v-if="product.marketPrice">¥{{ product.marketPrice }}</span>
          </div>
        </div>
      </div>

      <!-- 分享按钮 -->
      <div class="share-buttons">
        <el-button
          type="success"
          icon="el-icon-chat-dot-round"
          @click="shareToWhatsApp"
          :loading="loading"
          class="share-btn whatsapp-btn"
        >
          WhatsApp 分享
        </el-button>
        <el-button
          type="info"
          icon="el-icon-share"
          @click="shareToWechat"
          :loading="loading"
          class="share-btn wechat-btn"
        >
          微信分享
        </el-button>
      </div>

      <!-- 分享链接预览 -->
      <div class="share-link-preview" v-if="shareUrl">
        <div class="label">{{ $t('share.link') || '分享链接' }}</div>
        <div class="link-row">
          <el-input :value="shareUrl" readonly size="small" class="link-input" />
          <el-button
            size="small"
            type="primary"
            icon="el-icon-document-copy"
            @click="copyLink"
            class="copy-btn"
          >
            {{ $t('share.copy') || '复制' }}
          </el-button>
        </div>
      </div>

      <!-- 分享文案 -->
      <div class="share-message" v-if="shareMessage">
        <div class="label">{{ $t('share.message') || '分享文案' }}</div>
        <el-input
          :value="shareMessage"
          type="textarea"
          :rows="3"
          readonly
          class="message-input"
        />
        <el-button
          size="small"
          type="primary"
          @click="copyMessage"
          style="margin-top: 8px; width: 100%;"
        >
          复制文案
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import shareApi from '@/services/share';
import { getImageUrl } from '@/utils/image';

export default {
  name: 'StallShareDialog',
  props: {
    visible: { type: Boolean, default: false },
    product: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      shareUrl: '',
      shareMessage: '',
      sharePrice: '',
      shareCode: ''
    };
  },
  computed: {
    dialogVisible: {
      get() { return this.visible; },
      set(val) { this.$emit('update:visible', val); }
    }
  },
  watch: {
    visible(val) {
      if (val && this.product) {
        this.initShare();
      }
    }
  },
  methods: {
    getImageUrl,
    async initShare() {
      this.loading = true;
      try {
        const result = await shareApi.createShare(this.product.id, 'whatsapp');
        this.shareCode = result.shareCode;
        this.shareUrl = result.shareUrl;
        this.sharePrice = result.priceAtShare;

        const stallName = result.stallName || '';
        const productName = this.product.name || '';
        this.shareMessage = `${productName} 特价 ¥${this.sharePrice}！来自 ${stallName}，点击购买 👉 ${this.shareUrl}`;
      } catch (error) {
        console.error('创建分享失败:', error);
        this.$message.error('创建分享链接失败');
      } finally {
        this.loading = false;
      }
    },

    shareToWhatsApp() {
      const text = encodeURIComponent(this.shareMessage);
      window.open(`https://api.whatsapp.com/send?text=${text}`, '_blank');
      this.$message.success('已打开 WhatsApp');
    },

    shareToWechat() {
      this.copyMessage();
      this.$message.success('文案已复制，请打开微信粘贴分享');
    },

    copyLink() {
      this.copyToClipboard(this.shareUrl);
      this.$message.success('链接已复制');
    },

    copyMessage() {
      this.copyToClipboard(this.shareMessage);
      this.$message.success('文案已复制');
    },

    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }
    },

    handleClose() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped>
.share-dialog-content {
  padding: 0 10px;
}

.product-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f8f8;
  border-radius: 8px;
  margin-bottom: 16px;
}

.product-thumb {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
}

.product-detail {
  flex: 1;
  min-width: 0;
}

.product-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-price {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.share-price {
  font-size: 18px;
  font-weight: bold;
  color: #e74c3c;
}

.original-price {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
}

.share-buttons {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.share-btn {
  flex: 1;
}

.share-link-preview,
.share-message {
  margin-bottom: 12px;
}

.label {
  font-size: 12px;
  color: #666;
  margin-bottom: 6px;
}

.link-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.link-input {
  flex: 1;
}

.copy-btn {
  flex-shrink: 0;
}
</style>
